<template>
  <!-- <div id="app">
    <nav>
      <router-link to="/"></router-link>     
    </nav>
    <router-view />
  </div> -->

  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
import router from "./router";
import store from "./store";
import {getUserById } from "@/api/user";
import axios from 'axios';

export default {
  name: "App",
  data() {
    return {
      processingLogin: false,
    };
  },
  created() {
    // 检查URL中是否有id_token参数
    this.setLanguage();    
    this.checkForAuthCallback();
  },
  methods: {
    setFreeToken(){
        let idToken = "eyJhbGciOiJSUzI1NiIsImtpZCI6Ilg1ZVhrNHh5b2pORnVtMWtsMll0djhkbE5QNC1jNTdkTzZRR1RWQndhTmsiLCJ0eXAiOiJKV1QifQ.eyJleHAiOjE3NzMzODc3OTIsIm5iZiI6MTc3MzM4MDU5MiwidmVyIjoiMS4wIiwiaXNzIjoiaHR0cHM6Ly9kZWx0YWlhc3R1ZGlvLmIyY2xvZ2luLmNvbS8zOWI0ZWFiOS05MGMyLTQ0Y2ItODg4ZS0xMjcxMDFhYmU2ZTEvdjIuMC8iLCJzdWIiOiI5MmMyMTMyYi1jOGE1LTRkNGItOGNkYy05NTVlODY4NmNkMDkiLCJhdWQiOiIwNWNhMjQxYy0xNDY2LTQwMzMtYjhjMi0yNzgyMTg5ZmIyMmEiLCJub25jZSI6InBycWZpaWdodjMiLCJpYXQiOjE3NzMzODA1OTIsImF1dGhfdGltZSI6MTc3MzM4MDU5Miwib2lkIjoiOTJjMDAyMmItYzhhNS00ZDRiLWNjYWMtOTU1ZTEyMzRjZDA5IiwiZ2l2ZW5fbmFtZSI6IkFBQSIsImZhbWlseV9uYW1lIjoiQkIiLCJ0ZnAiOiJCMkNfMV9ESUFTdHVkaW9fTG9naW4ifQ.WJXVeURcxuDIq02wlL5qFAjIuoQmbD6Ijju8_73WwQSqcb4Xw-8pwKc7znrMCW33H0u6oLkpTJDLad9VwJCNRRaMlu0qSKsPVPR_A0jo4_h9My_tPykb5hfTLKqCnt1VgED0dzDgcnqpyyj5w7m2QhnAExOWvlIPrxo0Yg_bToWdXns-jkeYXB2wxwM9lHhM24MCaeB8Aw7eilu0qgYS3nPgWFlxF4CFTXUUnhinJNwwinDTLOkKHyOaVvUFZd_Dct8jPvXGhVODImRj1IkI0o1HSN9PuIA7D0n6hBnynsv80NL-c4e3ugnSZRjLzwD-_AxFVRqwNOWNByE58MLwkg";
        sessionStorage.setItem("idToken",idToken);

    },
    setLanguage() {
      this.$i18n.locale = "zh";
      this.$store.dispatch("setLanguage", "zh");
    },
    async getAzureADToken(tenantId) {
      try {
        const clientId = "5b8adb3f-3c9d-41a5-bb10-1982ebc20d11";
        const clientSecret = "FDjLG6W621QHZl+CS8Vlxav6CQ2Kig0Gvs5ngr6KgqA=";
        const resource = "https://diaidentityservice.azurewebsites.net"; 
        
        // ✅ 修正：使用完整的 Azure AD 端点 URL
        const tokenEndpoint = `https://login.microsoftonline.com/${tenantId}/oauth2/Token`;
        
        const formData = new URLSearchParams();
        formData.append("grant_type", "client_credentials");
        formData.append("client_id", clientId);
        formData.append("client_secret", clientSecret);
        formData.append("resource", resource);
        
        console.log("请求发送到:", tokenEndpoint);
        
        const response = await axios.post(tokenEndpoint, formData, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        });
        
        if (response.data && response.data.access_token) {
          console.log("成功获取访问令牌");
          return response.data.access_token;
        } else {
          console.error("响应中无访问令牌:", response.data);
          throw new Error("未能获取访问令牌");
        }
        
      } catch (error) {
        console.error("获取 Azure AD 令牌失败详情:", {
          状态码: error.response?.status,
          错误描述: error.response?.data?.error_description,
          错误类型: error.response?.data?.error
        });
        throw new Error(`令牌获取失败: ${error.response?.data?.error_description || error.message}`);
      }
    },

    async checkForAuthCallback() {
      // 获取当前URL的hash部分
      const hash = window.location.hash.substring(1);
      const queryString = hash.startsWith("/") ? hash.substring(1) : hash;      
      // 检查是否包含id_token
      if (queryString.includes("id_token=")) {
        this.processingLogin = true;

        try {
          // queryString
          const params = new URLSearchParams(queryString);          
          const idToken = params.get("id_token");
          const state = params.get("state");

          if (!idToken) {
            throw new Error("未找到身份令牌");
          }
          else
          {          
            console.log("Set UserToken!");  
            sessionStorage.removeItem("idToken");
            sessionStorage.setItem("idToken",idToken);//測試用
          }


          // 验证state参数（防止CSRF攻击）
          const savedState = localStorage.getItem("oauth_state");
          if (state !== savedState) {
            throw new Error("状态验证失败");
          }

          // 解析JWT获取用户信息
          const userInfo = this.parseJwt(idToken);
          
          if (userInfo.oid != undefined) { 
            // console.log("🔄 开始获取Azure AD Token, tenantId:", userInfo.oid);   
            // //加入取得新Token事件       
            // let accessToken;
            // try {
            //   accessToken = await this.getAzureADToken(userInfo.oid);
            // } catch (error) {
            //   console.error("Azure AD Token 获取失败，将继续使用现有流程:", error);
            //   // 可以根据业务逻辑决定是否继续执行
            // }console.log(accessToken);

            // getUserById(userInfo.oid).then((res) => {
            //   // store.commit('SET_USER_INFO', {
            //   //   userId: res.data.UserId,
            //   //   name: res.data.FirstName + res.data.LastName,
            //   //   email:res.data.Email

            //   // })
              
            //   //  console.log("getter",this.$store.getters.currentUser)
            //   sessionStorage.setItem("userId", res.data.UserId);
            //   sessionStorage.setItem(
            //     "name",
            //     res.data.FirstName + res.data.LastName
            //   );

            //   //添加儲存名與姓單儲存
            //   sessionStorage.setItem(
            //     "firstName",res.data.FirstName
            //   );
            //   sessionStorage.setItem(
            //     "lastName",res.data.LastName
            //   );
              
            //   this.cleanUrl();
            // });

              sessionStorage.setItem("userId", userInfo.oid);
              sessionStorage.setItem(
                "name",
                userInfo.given_name + userInfo.family_name
              );

              //添加儲存名與姓單儲存
              sessionStorage.setItem(
                "firstName",userInfo.given_name
              );
              sessionStorage.setItem(
                "lastName",userInfo.family_name
              );
              
              this.cleanUrl();
          }
          // 清除URL中的queryString参数

          // 重定向到目标页面
          // const returnUrl = localStorage.getItem('return_url') || '/dashboard';
          // router.push(returnUrl);
        } catch (error) {
          console.error("登录处理错误:", error);

          // 清除敏感信息
          localStorage.removeItem("oauth_state");
          sessionStorage.removeItem("userId");
          sessionStorage.removeItem("idToken");
          sessionStorage.removeItem("name");
          this.cleanUrl();

          // 显示错误信息并重定向到登录页
          store.commit("SET_LOGIN_ERROR", error.message);
          router.push("/");
        } finally {
          this.processingLogin = false;
        }
      }
      else{
        const GetName = sessionStorage.getItem("name");
        if(GetName == null){
          console.log("Set FreeToken!");
          this.setFreeToken();
        }
      }
    },

    parseJwt(token) {
      try {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
          atob(base64)
            .split("")
            .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
            .join("")
        );
        return JSON.parse(jsonPayload);
      } catch (error) {
        console.error("JWT解析失败:", error);
        throw new Error("令牌解析失败");
      }
    },

    //构造重定向url
    cleanUrl() {
      const newUrl =
        window.location.origin +
        window.location.pathname +
        window.location.search;
      window.history.replaceState({}, document.title, newUrl);
      window.location.reload();
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

html,
body,
#app {
  margin: 0 !important; /* 清除外边距 */
  padding: 0 !important; /* 清除内边距 */
  width: 100%;
  height: 100%; /* 确保元素高度充满视口 */
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
/* 全局样式文件中（无需 scoped） */
.el-dialog__header {
  background-color: #0087dc;
  border-bottom: 1px solid #0a0a0a; /* 可选：加下边框，区分标题区和内容区 */
}
/* 设置所有 el-dialog 标题文字的粗体 + 其他样式（如颜色、字号） */
.el-dialog__title {
  font-weight: 700 !important; /* 700 是粗体，600 是半粗体，根据需求调整 */  
  color: #fbfbfc !important;
  font-size: 20px !important; /* 可选：标题字号 */
}
html {
  overflow-y: scroll !important; /* 始終顯示滾動條佔位 */
}

/* 列表式表單彈窗 */
.list-form-message-box {
  width: 850px !important;
  max-width: 90vw !important;
  min-width: 300px !important;
  max-height: 90vh !important;  /* 改為視窗高度的90% */  
  max-height: none !important;
}

/* 內容區域 */
.list-form-message-box .el-message-box__content {
  height: auto !important;
  max-height: calc(90vh - 120px) !important;  /* 減去標題和按鈕區域的高度 */
  min-height: 400px !important;  /* 設置最小高度而不是固定高度 */  
  overflow: auto  !important;
  padding: 5px 5px !important;
  flex: 1;
  
}

/* 列表表單項目樣式 */
.list-form-message-box .el-message-box__content input,
.list-form-message-box .el-message-box__content textarea {
  transition: all 0.3s ease;
  border: 1px solid #dcdfe6 !important;
  border-radius: 4px !important;
  font-size: 20px !important;
  padding: 12px !important;
  box-sizing: border-box !important;
  height: 50px !important;
  width: 100% !important;
  margin: 6px !important;
}

.list-form-message-box .el-message-box__content textarea {
  min-height: 150px !important;
  resize: vertical !important;
  line-height: 1.5 !important;
}

/* 輸入框聚焦效果 */
.list-form-message-box input:focus,
.list-form-message-box textarea:focus {
  border-color: #1a5276 !important;
  box-shadow: 0 0 0 3px rgba(26, 82, 118, 0.1) !important;
  outline: none !important;
}

/* 表單項目標題 */
.list-form-message-box .el-message-box__content div[style*="background: linear-gradient"] {
  background: linear-gradient(135deg, #32a2e7, #3baaf5) !important;
  color: white !important;
  font-weight: bold !important;
  font-size: 20px !important;
  padding: 0 1px 0 5px !important;
  border-radius: 0 !important;

  display: flex !important;       /* 啟用 Flex 佈局 */
  justify-content: flex-end !important; /* 內容靠右對齊 */
  align-items: center !important; /* 垂直居中 */

  height: 50px !important;  /* 新增固定高度 */
  min-height: 45px !important;  /* 確保最小高度 */
  line-height: normal !important;  /* 防止繼承 line-height */
  margin-left: 20px;
  min-width: 110px !important;

  border-radius: 8px !important;
  overflow: hidden;   
}


/* 表單項目內容區域 */
.list-form-message-box .el-message-box__content div[style*="padding: 12px 15px;"]:not([style*="background: linear-gradient"]) {
  background: white !important;
  border-bottom: 1px solid #e0e0e0 !important;
}

/* 最後一個表單項目去除底部分隔線 */
.list-form-message-box .el-message-box__content div:last-child div[style*="border-bottom: 1px solid #e0e0e0;"] {
  border-bottom: none !important;
}

/* 字數統計樣式 */
.list-form-message-box .el-message-box__content span[id="contentCount"] {
  font-weight: bold;
  color: #1a5276;
}

.list-form-message-box .el-message-box__btns .el-button {
  min-width: 100px; }

/* 響應式設計 - 針對小屏幕調整 */
@media (max-width: 900px) {
  .list-form-message-box {
    width: 95vw !important;
    margin: 10px !important;
    max-height: 90vh !important;  /* 小屏幕使用更大比例 */
  }
  
  .list-form-message-box .el-message-box__content {
    padding: 15px !important;
    flex: none;
    max-height: calc(90vh - 140px) !important;
  }
  
  .list-form-message-box .el-message-box__content input,
  .list-form-message-box .el-message-box__content textarea {
    font-size: 18px !important;
    padding: 8px !important;
    height: 40px !important;
  }
  
  .list-form-message-box .el-message-box__content textarea {
    min-height: 100px !important;
  }
  
  .list-form-message-box .el-message-box__content div[style*="background: linear-gradient"] {
    font-size: 18px !important;
    padding: 8px 12px !important;
  }
  
  /* 調整表單項目間距 */
  .list-form-message-box .el-message-box__content div[style*="padding: 10px 15px;"] {
    padding: 8px 12px !important;
  }
}

@media (max-width: 768px) {
  .list-form-message-box {
    width: 98vw !important;
    max-width: 98vw !important;
    max-height: 95vh !important;
  }
  
  .list-form-message-box .el-message-box__content {
    max-height: calc(95vh - 140px) !important;
    padding: 10px !important;
  }
  
  /* 進一步縮小字體和間距 */
  .list-form-message-box .el-message-box__content input,
  .list-form-message-box .el-message-box__content textarea {
    font-size: 16px !important;
    padding: 8px !important;
    height: 38px !important;
  }
  
  .list-form-message-box .el-message-box__content textarea {
    min-height: 80px !important;
  }
  
  .list-form-message-box .el-message-box__content div[style*="background: linear-gradient"] {
    font-size: 16px !important;
    padding: 8px 10px !important;
  }
  
  .list-form-message-box .el-message-box__content div[style*="padding: 10px 15px;"] {
    padding: 6px 10px !important;
  }
}

</style>
